import { useEffect, useLayoutEffect, useState } from 'react';

export const useIsMobile = () => {
  const [mobile, setMobile] = useState(() => window.matchMedia('(max-width: 767px)').matches);
  useEffect(() => {
    const media = window.matchMedia('(max-width: 767px)');
    const change = () => setMobile(media.matches);
    media.addEventListener('change', change);
    return () => media.removeEventListener('change', change);
  }, []);
  return mobile;
};

// A single viewport contract shared by navigation, toolbars and modal forms.
export const useMobileViewport = () => {
  useLayoutEffect(() => {
    const root = document.documentElement;
    const update = () => {
      const v = window.visualViewport;
      const hv = `${v?.height || window.innerHeight}px`; if (root.style.getPropertyValue('--app-viewport-height') !== hv) root.style.setProperty('--app-viewport-height', hv);  // LOT 79 · rien n'est réécrit s'il n'a pas changé
      if (root.dataset.appMobile !== String(window.innerWidth < 768)) root.dataset.appMobile = String(window.innerWidth < 768);
      const editable = document.activeElement?.matches('input,textarea,[contenteditable="true"]');
      const kb = String(Boolean(editable && v && window.innerHeight - v.height > 140)); if (root.dataset.appKeyboard !== kb) root.dataset.appKeyboard = kb;
    };
    // LOT 79 · première pose sans mesurer la page (innerHeight ne force aucun calcul) ; la mesure fine attend l'image suivante
    if (root.dataset.appMobile !== String(window.innerWidth < 768)) root.dataset.appMobile = String(window.innerWidth < 768);
    if (!root.style.getPropertyValue('--app-viewport-height')) root.style.setProperty('--app-viewport-height', `${window.innerHeight}px`);
    const raf = requestAnimationFrame(() => setTimeout(update, 0));
    window.addEventListener('resize', update);
    window.visualViewport?.addEventListener('resize', update);
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', update);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', update);
      window.visualViewport?.removeEventListener('resize', update);
      document.removeEventListener('focusin', update);
      document.removeEventListener('focusout', update);
    };
  }, []);
};